import PropTypes from 'prop-types';
import React from 'react';

export const AppLogo = ({ logo, alt }) => {
  // TODO: Discuss how this needs to be done
  // eslint-disable-next-line global-require,import/no-dynamic-require
  const asset = require(`../../assets/images/${logo}`);
  return <img src={asset} alt={alt} style={{ maxHeight: '3em' }} />;
};

export default AppLogo;

AppLogo.propTypes = {
  logo: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

AppLogo.defaultProps = {
  alt: 'No image found',
};
